export const FLOW_BUILDER2_PAGE_NS = 'pages/FlowBuilder2Page';

export const i18n = {
  en: {
    buttons: {
      edit: 'Edit',
      apply: 'Apply',
      delete: 'Delete',
      duplicate: 'Duplicate',
      actions: 'Actions',
      publish: 'Publish',
      publishUpdates: 'Publish Updates',
      dontShowMeAgain: "Don't show me again",
      resetChanges: 'Reset Changes',
      openBuilder: 'Open builder',
      nextStep: 'Next Step',
      prevStep: 'Prev Step',
      retryAll: 'Retry All',
      addStep: 'Add step',
      addTask: 'Add task',
      addSection: 'Add section',
      openAdvancedEditor: 'Open Advanced Editor',
    },
    labels: {
      end: 'End',
      submit: 'Submit',
      then: 'Then',
      where: 'Where',
      value: 'Value',
      saving: 'Saving',
      savingError: 'Saving Error',
      workflow: 'Workflow',
      asset: 'Asset',
      assetType: 'Asset type',
      assetToUpdate: 'Asset to update',
      updateAssetValue: 'Update asset value',
      takeValueFrom: 'Take value from',
      selectComponent: 'Select Component',
      selectAssetSearchField: 'Select asset search field',
      selectAssetProperty: 'Select Asset Property',
      updateValueAt: 'Update value at',
      untitledWorkflow: 'Untitled Workflow',
      untitledAssetType: 'Untitled Asset Type',
      untitledStep: 'Untitled step',
      untitledTask: 'Untitled task',
      untitledSection: 'Untitled section',
      cancelled: 'Cancelled',
      declined: 'Declined',
      enable: 'Enable',
      select: 'Select',
      buttonAction: 'Button action',
      statusName: 'Status name',
      completionStatus: 'Completion status',
      defaultRecipient: 'Default Recipient',
      restrictedAccess: 'Restricted Access',
      defaultEditor: 'Default Editor',
      addActivity: 'Add activity',
      addAction: 'Add action',
      dropHere: 'Drop Here',
      restrictedTask: 'Restricted task',
      conditionApplied: 'Condition applied',
      hidden: 'Hidden',
      copy: 'Copy',
      reviewChanges: 'Review changes',
      tryAgain: 'Try again',
      accept: 'Accept',
      discard: 'Discard',
      continueEditing: 'Continue editing',
      pendingChanges: 'Pending changes',
      returnToUpdates: 'Return to updates',
      askDiana: 'Ask Diana',
      configuration: 'Configuration',
      disabled: 'Disabled',
      status: 'Status: {{ status }}',
      layout: 'Layout',
      code: 'Code',
      rules: 'Rules',
      properties: 'Properties',
    },
    titles: {
      duplicate: 'Duplicate',
      delete: 'Delete',
      rename: 'Rename',
      contents: 'Contents',
      components: 'Components',
      validation: 'Validation',
      taskActions: 'Task actions',
      editActionName: 'Edit {{ actionName }}',
      flowTypeNameReset: '{{ flowTypeName }} reset',
      somethingWentWrong: 'Something went wrong.',
      workflowPreview: 'Workflow Preview',
      workflowConfiguration: 'Workflow configuration',
      assetConfiguration: 'Asset type configuration',
      browserSmall: 'Your browser is too small',
      screenSmall: 'Your screen is too small',
      unsupportedComponent: '<> Code',
      editYamlOnly: 'Advance Edit-Yaml Only',
      actionRequired: 'Action required',
      updateAssetValue: 'Update Asset Value',
    },
    descriptions: {
      flowTypeNameResetSuccess: '{{ flowTypeName }} was successfully reset.',
      tryRefreshOrContactSupport:
        "We couldn't connect to the internet or our servers, please check the internet connection, and try refreshing the page in a few moments.",
      checkKnowledgeBase: 'Check our Knowledge Base to learn',
      checkValidationMessages: 'Please check validation messages.',
      unpublishedChangesWillNotBeSaved: 'Any unpublished changes will not be saved.',
      onlyPeopleCanSeeTaskDetails: 'Only people who assigned to this task can see its details',
      linkPeopleSearchField: 'Link a people search field',
      allowUserEditAndSubmitTask:
        'Link a “People Search” field from the previous task to allow this user to edit and submit this task',
      notAllRequiredFieldsAreFilled: 'Not all required fields are filled',
      layoutIsMissing: 'Layout is missing',
      dragAndDropComponents: 'Drag and drop components here',
      resizeBrowser: 'Resize your browser window to at least 1200px wide to return to builder mode',
      useDesktopDevice: 'To enable full functionality, use a desktop device.',
      resolveIssues: 'Please resolve all highlighted issues before publishing this workflow',
      endThisWork: 'End this work',
      forwardToNextTask: 'Forward to next task (Default)',
      needAiPendingAction: 'To continue, you need to accept or discard the AI pending changes',
    },
    prompts: {
      enterActionName: 'Enter action name',
      enterStatusName: 'Enter status name',
      linkPeopleSearchField: 'Choose people search field',
      ifActionWasCompleted: 'If the action was completed?',
      areYouSureToPublish: 'Are you sure you want to publish {{ flowTypeName }}?',
      areYouSUreToResetFlowTypeName:
        'Are you sure you want to reset {{ flowTypeName }} to its last published version?',
      areYouSureToDeleteActivityName:
        'Are you sure you want to delete "{{activityName}}" activity?',
      areYouSureToDeleteComponent: 'Are you sure you want to delete this component?',
      areYouSureToDeleteSubject: 'Are you sure you want to delete {{ subject }}?',
    },
    tooltips: {
      editFlowWithDiana: 'Edit workflow with Diana, your personal AI Assistant. Instant access  - ',
      resetToLastPublishedVersion: 'Reset to the last published version',
      advancedEditor: 'Advanced editor',
      preview: 'Preview',
      support: 'Support',
      settings: 'Settings',
      doubleClickToRename: 'Double click to rename',
      acceptPendingChanges: 'Accept pending changes to start new request.',
      deleteTask: 'Delete task',
      collapseLayers: 'Collapse layers',
      collapseContents: 'Collapse contents',
      expandContents: 'Expand contents',
      deleteAction: 'Delete action',
    },
    errors: {
      publishFlowFailed: 'Failed to publish flow',
      loadLayoutFailed: 'Failed to load layout',
      createDefaultSectionFailed: 'Failed to create default section',
      addStepFailed: 'Failed to add step',
      addTaskFailed: 'Failed to add task',
      addSectionFailed: 'Failed to add section',
      addActionFailed: 'Failed to add action',
      addActivityFailed: 'Failed to add activity',
      deleteStepFailed: 'Failed to delete step',
      deleteTaskFailed: 'Failed to delete task',
      deleteActivityFailed: 'Failed to delete activity',
      deleteComponentFailed: 'Failed to delete component',
      duplicateComponentFailed: 'Failed to duplicate component',
      moveComponentFailed: 'Failed to move component',
      acceptFailed: 'Failed to accept changes',
      discardFailed: 'Failed to discard changes',
      editStatusFetchFailed: 'Failed to fetch AI edit status',
    },
  },
};
